import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {useProductMediaState} from 'modules/product-card/mediaState/useProductMediaState';
import {MediaSliderModal} from 'modules/modals/components/MediaSliderModal';
import React, {useState} from 'react';
import {hideModal} from 'modules/modals/thunks';
import {MODALS} from 'modules/modals/constants';
import {useResize} from 'core/hooks/useResize';
import {getWindowInnerHeight, getWindowInnerWidth} from 'core/helpers';

export const ProductVideoModal = () => {
    const [iframeParams, setIframeParams] = useState({
        height: Math.min(getWindowInnerHeight(), 568),
        width: Math.min(getWindowInnerWidth(), 1008),
    });

    useResize(() => {
        setIframeParams({
            height: Math.min(getWindowInnerHeight(), 568),
            width: Math.min(getWindowInnerWidth(), 1008),
        });
    });

    const [{mediaSrc}, setProductMediaState] = useProductMediaState();

    const dispatch = useAppDispatch();

    const onCloseModal = () => {
        setProductMediaState(() => ({mediaSrc: null, mediaType: null}));
        dispatch(hideModal(MODALS.PRODUCT_VIDEO_MODAL.name));
    };

    return (
        <MediaSliderModal
            isVideo={true}
            onClose={() => {
                onCloseModal();
            }}
        >
            <iframe
                width={`${iframeParams.width}px`}
                height={`${iframeParams.height}px`}
                src={mediaSrc ?? undefined}
                frameBorder={'0'}
                allow={'autoplay'}
            ></iframe>
        </MediaSliderModal>
    );
};

export default ProductVideoModal;
